import { AxiosError } from "axios";
import { ApiValidationError } from "../models/ApiValidationError";
import { FieldValues, Path, useForm } from "react-hook-form";

const applyApiValidationErrors = <T extends FieldValues>(
  error: AxiosError<ApiValidationError>,
  setError: ReturnType<typeof useForm<T>>["setError"]
) => {
  const fieldErrors = error?.response?.data?.errors;
  if (!fieldErrors) return;

  Object.entries(fieldErrors).forEach(([field, messages]) => {
    if (Array.isArray(messages)) {
      setError(field as Path<T>, {
        type: "server",
        message: messages[0],
      });
    }
  });
};

export default applyApiValidationErrors